var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "detail-dropdown-box" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "tit" }, [
          _vm._v(_vm._s(/*신청 내역*/ _vm.$t("PCOP-02-01-02-03")))
        ]),
        _c("i", {
          staticClass: "icon icon-dropdown-m-arrow",
          class: { rotate: !_vm.show1 },
          on: {
            click: function($event) {
              _vm.show1 = !_vm.show1
            }
          }
        })
      ]),
      _vm.show1
        ? _c("div", { staticClass: "content" }, [
            _c("dl", { staticClass: "dlist dlist-item--type4" }, [
              _c("dt", [_vm._v(_vm._s(/*등록자*/ _vm.$t("PCOP-02-01-02-04")))]),
              _c("dd", [
                _vm._v(_vm._s(_vm.RCA040DA40Response.regiWWWBnkgLginID))
              ]),
              _c("dt", [
                _vm._v(_vm._s(/*등록 시간*/ _vm.$t("PCOP-02-01-02-05")))
              ]),
              _c("dd", [_vm._v(_vm._s(_vm.RCA040DA40Response.aprvalRegiYmd))]),
              _c("dt", [
                _vm._v(_vm._s(/*등록 메모*/ _vm.$t("PCOP-02-01-02-06")))
              ]),
              _c("dd", [_vm._v(_vm._s(_vm.RCA040DA40Response.aprvalMemoCtnt))])
            ])
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "detail-dropdown-box" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "tit" }, [
          _vm._v(_vm._s(/*결재 진행*/ _vm.$t("PCOP-02-01-02-07")))
        ]),
        _c("i", {
          staticClass: "icon icon-dropdown-m-arrow",
          class: { rotate: !_vm.show2 },
          on: {
            click: function($event) {
              _vm.show2 = !_vm.show2
            }
          }
        })
      ]),
      _vm.show2
        ? _c("div", { staticClass: "content" }, [
            _c(
              "dl",
              { staticClass: "dlist dlist-item--type4 approval" },
              [
                _vm._l(_vm.RCA040DA40Response.list, function(data, i) {
                  return [
                    _c("dt", { key: "dt" + i }, [
                      _vm._v(
                        _vm._s(i + 1) + _vm._s(/*단계*/ _vm.$t("MCOM-0000012"))
                      )
                    ]),
                    data.aprvalPnm
                      ? _c(
                          "dd",
                          { key: "dd" + i },
                          [
                            _vm._v(
                              " " +
                                _vm._s(data.aprvalPnm) +
                                " " +
                                _vm._s(
                                  data.isHoAprvalUser
                                    ? /*한국본사*/ _vm.$t("MCOM-0000013")
                                    : ""
                                ) +
                                " " +
                                _vm._s(
                                  data.prcssStusDstNm != ""
                                    ? "/" + _vm.$t(data.prcssStusDstNm)
                                    : ""
                                ) +
                                " "
                            ),
                            data.aprvalYmd
                              ? [
                                  _c("br"),
                                  _vm._v(" (" + _vm._s(data.aprvalYmd) + ") ")
                                ]
                              : _vm._e(),
                            _c("div", { staticClass: "badge-group" }, [
                              data.aprvalPsn == _vm.regiWwwBnkgLginId
                                ? _c("i", { staticClass: "icon icon-me" })
                                : _vm._e(),
                              data.targetYn == "Y"
                                ? _c("i", { staticClass: "icon icon-com" })
                                : _vm._e()
                            ])
                          ],
                          2
                        )
                      : _c("dd", { key: "dd" + i, staticClass: "etc" }, [
                          _vm._v("N/A")
                        ])
                  ]
                })
              ],
              2
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }